export default {
  not_set_up: {
    title: "Reservations aren't set up for this location yet",
    description:
      "A location gets reservations once it is linked to its Google listing and has an owner. If the restaurant has no owner yet, add one under Team. Until then there are no reservation opening hours to edit here, and changes to the Online Shop hours aren't copied to Reservations.",
  },
  company_not_loaded: {
    title: 'Reservation settings could not be loaded',
    description:
      "This location's reservation settings could not be loaded, so its reservation opening hours can't be edited right now. Please try again.",
    retry: 'Try again',
  },
};
